import React from 'react';

const SettingsLoader = () => {
  return (
    <div className="section-loader loading">
      <ul className="loading-dots">
        <li />
        <li />
        <li />
      </ul>
    </div>
  );
};

export default SettingsLoader;
